import { Attributes, Misc, ModelBase, NeoModel } from "@singularsystems/neo-core";
import SFTPBrokerDetailsLookup from "../Lookups/SFTPBrokerDetailsLookup";
import { TradeDistributionTypeEnum } from "../Enums/TradeDistributionTypeEnum";
import SaveFileGroupingExportSettingCommand from "./SaveFileGroupingExportSettingCommand";

@NeoModel
export default class SaveServiceProviderFileGroupingCommand extends ModelBase {

    public staticServiceProviderFileGroupingId: number = 0;

    public staticServiceProviderId: number = 0;

    public serviceProviderName: string = "";

    public serviceProviderCode: string = "";

    public serviceProviderSubAccountName: string = "";

    public serverName: string = "";

    public serviceProviderGroupingName: string = "";

    public groupingDescription: string = "";

    public databaseName: string = "";

    public isOnshoreInd: boolean = false;

    public ignoreGroupingInd: boolean = false;

    public isActiveInd: boolean = false;

    public importsPublicHolidaysInd: boolean = false;

    public ignoresExchangeRatesInd: boolean = false;

    public clientAltSearchInd: boolean = false;

    public sortOrder: string = "";

    public provideDividendGrossInd: boolean = false;

    public useAccountCurrencyInd: boolean = false;

    public isWacEnabled: boolean = false;

    public eventIdFieldName: string = "";

    public saveFileGroupingExportSettingCommandList: SaveFileGroupingExportSettingCommand[] = [];

    public tradeDistributionTypeId: TradeDistributionTypeEnum | null = null;

    public sftpBrokerDetailsLookups: SFTPBrokerDetailsLookup[] = [];

    public samReporting: number | null = null;

    public isBroker: boolean = true;

    public isBookCostRunning: boolean = false;

    public exportToSFTP: boolean = false;

    public exportToAPI: boolean = false;

    public criticalFailureRecipients: string | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.UTC)
    public lastDailyReportSync: Date | null = null;
}